import React, { useEffect } from "react";
import { Box, Flex, Text, Circle, useBreakpointValue, useFocusEffect } from "@chakra-ui/react";
import { useSelector, useDispatch } from "react-redux";
import { setCurrentStep } from "../reducers/LocationSlice";
import { useTranslation } from "react-i18next";
import Utils from "../services/Utils";

const steps = [
  { number: 1, titleKey: "steps.select_service", subtitleKey: "steps.step" },
  { number: 2, titleKey: "steps.service_theme", subtitleKey: "steps.step" },
  { number: 3, titleKey: "steps.select_date_time", subtitleKey: "steps.step" },
  { number: 4, titleKey: "steps.booking_details", subtitleKey: "steps.step" },
  { number: 5, titleKey: "steps.payment", subtitleKey: "steps.step" },
];

const SideBar = () => {
  const { t, i18n } = useTranslation();
  const {
    selectedLocationName,
    selectedServiceName,
    currentStep,
    selectedServiceId,
  } = useSelector((state) => state.location);
  const { sessionsTypeStored } = useSelector((state) => state.sessionType);
  const bookingState = useSelector((state) => state.booking);
  const dispatch = useDispatch();

  const handleStepClick = (stepNumber) => {
    if (
      stepNumber <= currentStep ||
      (stepNumber === 2 && sessionsTypeStored) ||
      (stepNumber === 3 && selectedServiceId)
    ) {
      dispatch(setCurrentStep(stepNumber));
    }
  };

  // useEffect(() => {
  // console.log("bookingState", bookingState, selectedServiceName);
  // }, [bookingState, selectedServiceName])

  return (
    <>
      {/* Sidebar - Only visible on desktop */}
      <Box
        display={{ base: "none", md: "block" }} // Hide on mobile
        bg="white"
        padding="2rem 1rem"
        borderRight="2px solid"
        borderRightColor="gray.200"
        maxW={{ md: "300px", lg: "350px" }}
        minW="250px"
      >
        {/* Step List */}
        {steps.map((step) => (
          <Flex
            key={step.number}
            align="center"
            bg={currentStep === step.number ? "gray.100" : "white"}
            borderRadius="md"
            padding="1rem"
            marginBottom="1rem"
            cursor={
              step.number <= currentStep ||
                (step.number === 2 && sessionsTypeStored) ||
                (step.number === 3 && selectedServiceId)
                ? "pointer"
                : "default"
            }
            onClick={() => handleStepClick(step.number)}
            transition="background-color 0.2s ease, box-shadow 0.2s ease"
            border="1px solid"
            borderColor={currentStep === step.number ? "#FF6666" : "gray.300"}
          >
            <Circle size="40px" bg="#FF6666" color="white" marginRight="1rem">
              <Text fontSize="xl">{step.number}</Text>
            </Circle>
            <Box>
              <Text fontWeight="bold" fontSize={{ base: "sm", md: "md" }}>
                {t(step.titleKey)}
              </Text>
              <Text fontSize={{ base: "xs", md: "sm" }} color="gray.500">
                {`${t(step.subtitleKey)} ${step.number}`}
              </Text>
              <Text fontSize={{ base: "xs", md: "sm" }} color="gray.500">
                {step.number === 1 ?
                  (bookingState?.service
                    ? `${i18n.language === 'fr' ? bookingState.service.name_fr : bookingState.service.name_en}`
                    : '')
                  : ''}

                {step.number === 2 ?
                  (bookingState?.serviceType
                    ? `${i18n.language === 'fr' ? bookingState.serviceType.name_fr : bookingState.serviceType.name_en}`
                    : '')
                  : ''}


                {step.number === 3
                  ? (bookingState?.dateAndTimeSlot?.selectedDate && bookingState?.dateAndTimeSlot?.selectedTimeSlot?.time
                    ? `${bookingState.dateAndTimeSlot.selectedDate} - ${Utils.convertUTCToLocalTimeZone(bookingState.dateAndTimeSlot.selectedTimeSlot.time)}`
                    : '')
                  : ''}

                {/* {step.number === 4 ?
                  (bookingState?.bookingDetails?.[0]?.participants?.[0]?.name
                    ? bookingState.bookingDetails[0].participants[0].name
                    : '')
                  : ''} */}


              </Text>
            </Box>
          </Flex>
        ))}
      </Box>

      {/* Mobile: Completely hide the step indicator */}
      <Box display={{ base: "none", md: "block" }} />
    </>
  );
};

export default SideBar;
